import { normalizeToTableBonusRequests } from './TableBonusRequest'
export const normalizeToTableRaiseRequests = (serverRaiseRequest) => {
  const employee = serverRaiseRequest.employee
  return {
    ...normalizeToTableBonusRequests(serverRaiseRequest),
    qualificationLabel: employee.qualification.label,
    newQualificationLabel: serverRaiseRequest.new_qualification.label,
  }
}
